import { Component, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-create-azure-account-dialog',
  templateUrl: './create-azure-account-dialog.component.html',
  styleUrl: './create-azure-account-dialog.component.scss'
})
export class CreateAzureAccountDialogComponent {
  linkOpened: boolean = false;

  constructor (
    private dialogRef: MatDialogRef<CreateAzureAccountDialogComponent>,
    ) {}

  close() {
    this.dialogRef.close();
  }

  openLink() {
    window.open(environment.galileoAzure, '_blank');
    this.linkOpened = true;
  }

  refreshPage(): void {
    window.location.reload();
  }

}
